import i18n from "@/plugins/i18n";

export default {
    data() {
        return {
            requiredRule: (v) => !!v || i18n.t('servicesystem.rules.required_field'),
            emailRule: (v) => !v || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || i18n.t('servicesystem.rules.valid_mail'),
            phoneRule: (v) => !v || /^[0-9 +#-]*$/.test(v) || i18n.t('servicesystem.rules.valid_tlf'),
            intRule: (v) => !v || /^[0-9]*$/.test(v) || i18n.t('servicesystem.rules.valid_int'),
            floatRule: (v) => !v || /^[0-9 .,]*$/.test(v) || i18n.t('servicesystem.rules.valid_decimal'),
            noEnterRule: (v) => !v || !v.includes('\n') || i18n.t('servicesystem.rules.no_enter'),
            passwordRules: [
                (value) => (value && value.length >= 6) || i18n.t('servicesystem.rules.requires_six_chars'),
                (value) =>
                    (value && /[A-Z]{1}/.test(value)) || i18n.t('servicesystem.rules.requires_capital_letter'),
                (value) => (value && /\d/.test(value)) || i18n.t('servicesystem.rules.requires_digit'),
                (value) =>
                    (value && /[^A-Za-z0-9]/.test(value)) || i18n.t('servicesystem.rules.requires_special_char'),
            ],
        };
    },
    methods: {

    }
}